/* Store homepage design — small behaviours for nf-* sections */
(function () {
  function init(root) {
    // Carousel arrows scroll their track.
    root.querySelectorAll('[data-nf-arrow]').forEach(function (btn) {
      if (btn.dataset.nfBound) return;
      btn.dataset.nfBound = '1';
      btn.addEventListener('click', function () {
        var shell = btn.closest('[data-nf-shell]');
        var track = shell && shell.querySelector('[data-nf-track]');
        if (!track) return;
        var dir = btn.dataset.nfArrow === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    // Review carousel dots follow scroll position.
    root.querySelectorAll('[data-nf-dots]').forEach(function (dots) {
      var shell = dots.closest('[data-nf-shell]');
      var track = shell && shell.querySelector('[data-nf-track]');
      if (!track || track.dataset.nfDots) return;
      track.dataset.nfDots = '1';
      var update = function () {
        var items = dots.children;
        if (!items.length) return;
        var max = track.scrollWidth - track.clientWidth;
        var i = max > 0 ? Math.round((track.scrollLeft / max) * (items.length - 1)) : 0;
        Array.prototype.forEach.call(items, function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    // Shelf tabs (phone layout).
    root.querySelectorAll('[data-nf-tabs]').forEach(function (tabs) {
      if (tabs.dataset.nfBound) return;
      tabs.dataset.nfBound = '1';
      var section = tabs.closest('[data-nf-shelves]');
      tabs.querySelectorAll('[data-nf-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.nfTab;
          tabs.querySelectorAll('[data-nf-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          section.querySelectorAll('[data-nf-shelf]').forEach(function (s) {
            s.classList.toggle('is-active', s.dataset.nfShelf === i);
          });
        });
      });
    });

    // Announcement close.
    root.querySelectorAll('[data-nf-close]').forEach(function (btn) {
      if (btn.dataset.nfBound) return;
      btn.dataset.nfBound = '1';
      btn.addEventListener('click', function () {
        var bar = btn.closest('[data-nf-announce]');
        if (bar) bar.style.display = 'none';
      });
    });

    // Footer columns: always open on desktop, collapsible on phones.
    var mq = window.matchMedia('(min-width: 990px)');
    var syncFooter = function () {
      root.querySelectorAll('[data-nf-collapsible]').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
        else if (!d.dataset.nfTouched) d.removeAttribute('open');
      });
    };
    root.querySelectorAll('[data-nf-collapsible] summary').forEach(function (s) {
      if (s.dataset.nfBound) return;
      s.dataset.nfBound = '1';
      s.addEventListener('click', function (e) {
        if (mq.matches) { e.preventDefault(); return; }
        s.parentElement.dataset.nfTouched = '1';
      });
    });
    syncFooter();
    if (!window.__nfMq) { window.__nfMq = true; mq.addEventListener('change', function () { syncFooter(); }); }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Re-bind when a section is edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('nf:rebind', function (e) { init(e.detail); });
})();

/* Product page: gallery thumbnails, options -> variant, quantity, related products */
(function () {
  function money(cents, fmt) {
    var n = (cents / 100);
    var fixed2 = n.toFixed(2), withComma = fixed2.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fixed2.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }
  function initPdp(root) {
    root.querySelectorAll('[data-nf-pdp]').forEach(function (pdp) {
      if (pdp.dataset.nfReady) return;
      pdp.dataset.nfReady = '1';
      var gallery = pdp.querySelector('[data-nf-gallery]');
      var thumbs = pdp.querySelectorAll('[data-nf-thumb]');
      var goTo = function (i) {
        if (!gallery || !gallery.children[i]) return;
        gallery.scrollTo({ left: gallery.children[i].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.nfThumb); }); });
      if (gallery) {
        gallery.addEventListener('scroll', function () {
          var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        }, { passive: true });
      }
      // variants
      var vEl = pdp.querySelector('[data-nf-variants]');
      if (!vEl) return;
      var variants = JSON.parse(vEl.textContent);
      var fmt = JSON.parse(pdp.querySelector('[data-nf-money]').textContent);
      var idInput = pdp.querySelector('[data-nf-variant-id]');
      var atc = pdp.querySelector('[data-nf-atc]');
      var atcLabel = pdp.querySelector('[data-nf-atc-label]');
      var now = pdp.querySelector('[data-nf-now]');
      var compare = pdp.querySelector('[data-nf-compare]');
      var badge = pdp.querySelector('[data-nf-salebadge]');
      var applyPack = function (v) {
        pdp.querySelectorAll('[data-nf-pack-opt]').forEach(function (up) {
          var n = parseInt(v && v.options[+up.dataset.nfPackOpt], 10) || 1;
          up.querySelectorAll('[data-nf-slot]').forEach(function (s, i) { s.hidden = i >= n; });
        });
      };
      if (idInput) applyPack(variants.find(function (x) { return String(x.id) === String(idInput.value); }) || variants[0]);
      var update = function (e) {
        var sel = [];
        pdp.querySelectorAll('[data-nf-opt]:checked').forEach(function (r) { sel[+r.dataset.nfOpt] = r.value; });
        pdp.querySelectorAll('[data-nf-optlabel]').forEach(function (l) { l.textContent = sel[+l.dataset.nfOptlabel] || ''; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); });
        if (!v && e && e.target && e.target.dataset) {
          // the combination doesn't exist (e.g. a square size has no "Portrait"): keep the option just picked
          // and switch the other options to the closest variant that has it
          var ci = +e.target.dataset.nfOpt, best = null, bestScore = -1;
          variants.forEach(function (x) {
            if (x.options[ci] !== sel[ci]) return;
            var s = x.options.filter(function (o, i) { return o === sel[i]; }).length + (x.available ? 0.5 : 0);
            if (s > bestScore) { bestScore = s; best = x; }
          });
          if (best) {
            best.options.forEach(function (o, i) {
              if (o === sel[i]) return;
              pdp.querySelectorAll('[data-nf-opt="' + i + '"]').forEach(function (r) {
                if (r.value === o && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
              });
            });
            return;
          }
        }
        if (!v) { if (atc) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; } return; }
        if (idInput) idInput.value = v.id;
        applyPack(v);
        if (atc) { atc.disabled = !v.available; atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (now) { now.textContent = money(v.price, fmt); now.classList.toggle('is-sale', !!onSale); }
        if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = money(v.compare_at_price, fmt); }
        if (badge) badge.hidden = !onSale;
        if (v.featured_media && gallery) {
          var slide = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (slide) goTo(Array.prototype.indexOf.call(gallery.children, slide));
        }
        if (window.history && history.replaceState && !pdp.hasAttribute('data-nf-embed')) {
          history.replaceState({}, '', pdp.dataset.url + '?variant=' + v.id);
        }
      };
      pdp.querySelectorAll('[data-nf-opt]').forEach(function (r) { r.addEventListener('change', update); });
    });

    // related products load after the page
    root.querySelectorAll('[data-nf-related]').forEach(function (sec) {
      if (sec.dataset.nfLoaded || sec.children.length) return;
      sec.dataset.nfLoaded = '1';
      fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-nf-related]');
        if (fresh && fresh.innerHTML.trim()) {
          sec.innerHTML = fresh.innerHTML;
          document.dispatchEvent(new CustomEvent('nf:rebind', { detail: sec }));
        }
      }).catch(function () {});
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initPdp(document); });
  document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
})();

/* Drawers (phone menu + cart) and add-to-cart without leaving the page */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function openDlg(dlg) {
    if (!dlg || dlg.open) return;
    dlg.showModal();
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDlg(dlg) {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-open');
    setTimeout(function () { dlg.close(); document.documentElement.style.overflow = ''; }, 300);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nf-open]');
    if (opener) {
      var dlg = document.getElementById(opener.dataset.nfOpen);
      if (dlg && dlg.showModal) { e.preventDefault(); openDlg(dlg); return; }
    }
    var closer = e.target.closest('[data-nf-close-dlg]');
    if (closer) { closeDlg(closer.closest('dialog')); return; }
    // click on the dimmed area outside a drawer
    if (e.target.matches && e.target.matches('dialog.nf-dlg')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDlg(e.target);
    }
  });
  document.addEventListener('cancel', function (e) {
    if (e.target.matches && e.target.matches('dialog.nf-dlg')) { e.preventDefault(); closeDlg(e.target); }
  }, true);

  function cartDlg() { return document.getElementById('NfCartDrawer'); }
  function applyCart(sections) {
    var html = sections && sections['nf-cart-drawer'];
    var dlg = cartDlg();
    if (!html || !dlg) return;
    dlg.innerHTML = html;
    var body = dlg.querySelector('[data-count]');
    var count = body ? body.dataset.count : null;
    if (count !== null) document.querySelectorAll('[data-nf-cart-count]').forEach(function (c) { c.textContent = count; });
  }
  function post(url, data) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  // quantity changes inside the cart drawer
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#NfCartDrawer [data-nf-line]');
    if (!b) return;
    var body = cartDlg().querySelector('.nf-cart');
    if (body) body.classList.add('is-busy');
    post('cart/change.js', { line: +b.dataset.nfLine, quantity: Math.max(0, +b.dataset.nfSet), sections: 'nf-cart-drawer' })
      .then(function (j) { applyCart(j.sections); })
      .catch(function () { location.href = root + 'cart'; });
  });

  // product page add to cart -> open drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.nf-pdp__form');
    if (!form || !cartDlg() || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-nf-atc]');
    var label = form.querySelector('[data-nf-atc-label]');
    var old = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    var fd = new FormData(form);
    fd.append('sections', 'nf-cart-drawer');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { applyCart(j.sections); openDlg(cartDlg()); document.dispatchEvent(new CustomEvent('nf:added', { detail: form })); })
      .catch(function (err) {
        var msg = form.querySelector('.nf-pdp__error');
        if (!msg) { msg = document.createElement('p'); msg.className = 'nf-pdp__error'; msg.setAttribute('role', 'alert'); form.appendChild(msg); }
        msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
      })
      .finally(function () { if (btn) btn.disabled = false; if (label) label.textContent = old; });
  });
})();

/* Quantity steppers (product page, cart page) and auto-submitting filter bars */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nf-qty-step]');
    if (!b || b.closest('#NfCartDrawer')) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + (+b.dataset.nfQtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-nf-autosubmit]');
    if (!form) return;
    if (e.target.type === 'number') return; // price inputs use the Apply button
    // drop empty fields so the URL stays clean
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && el.value === '' && el.type !== 'checkbox') el.disabled = true;
    });
    form.submit();
  });
  // Close an open filter when clicking elsewhere
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nf-filter[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();

/* Photo upload block (photo printing products) */
(function () {
  var SIZE_RE = /(\d+(?:\.\d+)?)\s*(?:"|in|inch(?:es)?)?\s*[x×X]\s*(\d+(?:\.\d+)?)/;

  function selectedSize(pdp) {
    var vals = [];
    pdp.querySelectorAll('[data-nf-opt]:checked').forEach(function (r) { vals.push(r.value); });
    for (var i = 0; i < vals.length; i++) {
      var m = vals[i].match(SIZE_RE);
      if (m) return { a: parseFloat(m[1]), b: parseFloat(m[2]), label: vals[i] };
    }
    return null;
  }

  function checkQuality(slot) {
    var up = slot.closest('[data-nf-upload]');
    var pdp = slot.closest('[data-nf-pdp]') || document;
    var warn = slot.querySelector('[data-nf-fwarn]');
    var img = slot.querySelector('[data-nf-preview]');
    warn.hidden = true;
    if (!img.naturalWidth) return;
    var size = selectedSize(pdp);
    if (!size) return;
    var dpi = parseInt(up.dataset.dpi, 10) || 150;
    var longPx = Math.max(img.naturalWidth, img.naturalHeight);
    var shortPx = Math.min(img.naturalWidth, img.naturalHeight);
    var longIn = Math.max(size.a, size.b), shortIn = Math.min(size.a, size.b);
    var actual = Math.min(longPx / longIn, shortPx / shortIn);
    if (actual < dpi) {
      warn.textContent = 'This photo may look blurry at ' + size.label + '. Try a smaller size or a higher-quality original.';
      warn.hidden = false;
    }
  }

  function showError(up, msg) {
    var el = up.querySelector('[data-nf-upload-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function fmtSize(bytes) {
    return bytes > 1048576 ? (bytes / 1048576).toFixed(1) + ' MB' : Math.round(bytes / 1024) + ' KB';
  }

  function clearSlot(slot) {
    var input = slot.querySelector('[data-nf-file]');
    var img = slot.querySelector('[data-nf-preview]');
    input.value = '';
    if (img.src && img.src.indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
    img.removeAttribute('src');
    slot.querySelector('.nf-upload__filled').hidden = true;
    slot.querySelector('.nf-upload__empty').hidden = false;
    slot.classList.remove('is-filled');
    var upEl = slot.closest('[data-nf-upload]');
    if (upEl) upEl.dispatchEvent(new CustomEvent('nf:media', { bubbles: true }));
  }

  function handleFile(slot) {
    var input = slot.querySelector('[data-nf-file]');
    var up = slot.closest('[data-nf-upload]');
    var file = input.files && input.files[0];
    if (!file) { clearSlot(slot); return; }
    var maxMb = parseFloat(up.dataset.maxMb) || 20;
    if (file.size > maxMb * 1048576) {
      clearSlot(slot);
      showError(up, file.name + ' is ' + fmtSize(file.size) + '. Please use a file under ' + maxMb + ' MB.');
      return;
    }
    showError(up, '');
    var img = slot.querySelector('[data-nf-preview]');
    var info = slot.querySelector('[data-nf-finfo]');
    slot.querySelector('[data-nf-fname]').textContent = file.name;
    info.textContent = fmtSize(file.size);
    slot.querySelector('.nf-upload__empty').hidden = true;
    slot.querySelector('.nf-upload__filled').hidden = false;
    slot.classList.add('is-filled');
    if (img.src && img.src.indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
    img.onload = function () {
      info.textContent = fmtSize(file.size) + ' · ' + img.naturalWidth + ' × ' + img.naturalHeight + ' px';
      checkQuality(slot);
      up.dispatchEvent(new CustomEvent('nf:media', { bubbles: true }));
    };
    img.onerror = function () {
      img.removeAttribute('src');
      info.textContent = fmtSize(file.size) + ' · preview not available, it will still print';
    };
    img.src = URL.createObjectURL(file);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-nf-file]')) handleFile(e.target.closest('[data-nf-slot]'));
    if (e.target.matches('[data-nf-opt]')) {
      var pdp = e.target.closest('[data-nf-pdp]');
      if (pdp) pdp.querySelectorAll('[data-nf-slot].is-filled').forEach(checkQuality);
    }
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-nf-remove]');
    if (!rm) return;
    e.preventDefault();
    clearSlot(rm.closest('[data-nf-slot]'));
  });

  // drag and drop onto a slot
  ['dragenter', 'dragover'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var slot = e.target.closest && e.target.closest('[data-nf-slot]');
      if (!slot) return;
      e.preventDefault();
      slot.classList.add('is-drag');
    });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var slot = e.target.closest && e.target.closest('[data-nf-slot]');
      if (!slot) return;
      slot.classList.remove('is-drag');
      if (t !== 'drop') return;
      e.preventDefault();
      var files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      var input = slot.querySelector('[data-nf-file]');
      try {
        var dt = new DataTransfer();
        dt.items.add(files[0]);
        input.files = dt.files;
      } catch (err) { return; }
      handleFile(slot);
    });
  });

  // one picker for a whole pack: spread the chosen photos over the pack's slots, in order
  function visibleSlots(up) {
    return Array.prototype.filter.call(up.querySelectorAll('[data-nf-slot]'), function (s) { return !s.hidden; });
  }
  function multiCount(up) {
    var out = up.querySelector('[data-nf-multi-count]');
    if (!out) return;
    var vis = visibleSlots(up);
    var filled = vis.filter(function (s) { return s.classList.contains('is-filled'); }).length;
    out.textContent = filled ? filled + ' of ' + vis.length + ' added' : vis.length + ' photos';
    out.classList.toggle('is-done', filled === vis.length);
    var pick = up.querySelector('[data-nf-multi-drop] b');
    if (pick) pick.textContent = filled ? (filled === vis.length ? 'Change photos' : 'Add more photos') : pick.dataset.label || pick.textContent;
  }
  function multiAdd(up, files) {
    var list = Array.prototype.filter.call(files || [], function (f) { return /^image\/|pdf|svg/.test(f.type) || /\.(heic|heif|jpe?g|png|webp|pdf|svg)$/i.test(f.name); });
    if (!list.length) return;
    var vis = visibleSlots(up);
    var empty = vis.filter(function (s) { return !s.classList.contains('is-filled'); });
    // all slots full already: start over with the new selection
    if (!empty.length) { vis.forEach(clearSlot); empty = vis; }
    var used = 0;
    empty.forEach(function (slot, i) {
      if (!list[i]) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(list[i]);
        slot.querySelector('[data-nf-file]').files = dt.files;
      } catch (err) { return; }
      handleFile(slot);
      used++;
    });
    if (list.length > used) {
      showError(up, 'Your pack holds ' + vis.length + ' photos, so we added the first ' + used + '. Choose a bigger pack to add the rest.');
    }
    multiCount(up);
  }
  document.querySelectorAll('[data-nf-multi-drop] b').forEach(function (b) { b.dataset.label = b.textContent; });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-nf-multi]')) {
      var up = e.target.closest('[data-nf-upload]');
      showError(up, '');
      multiAdd(up, e.target.files);
      e.target.value = '';
      return;
    }
    if (e.target.matches('[data-nf-file]')) { var u = e.target.closest('[data-nf-upload]'); if (u) setTimeout(function () { multiCount(u); }, 0); }
    if (e.target.matches('[data-nf-opt]')) {
      var pdp = e.target.closest('[data-nf-pdp]');
      if (!pdp) return;
      // a smaller pack hides some slots: drop the photos in them so they aren't ordered
      setTimeout(function () {
        pdp.querySelectorAll('[data-nf-upload]').forEach(function (up) {
          up.querySelectorAll('[data-nf-slot][hidden].is-filled').forEach(clearSlot);
          multiCount(up);
        });
      }, 0);
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nf-remove]')) return;
    var up = e.target.closest('[data-nf-upload]');
    if (up) setTimeout(function () { multiCount(up); }, 0);
  });
  ['dragenter', 'dragover'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var z = e.target.closest && e.target.closest('[data-nf-multi-drop]');
      if (!z) return;
      e.preventDefault();
      z.classList.add('is-drag');
    });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var z = e.target.closest && e.target.closest('[data-nf-multi-drop]');
      if (!z) return;
      z.classList.remove('is-drag');
      if (t !== 'drop') return;
      e.preventDefault();
      multiAdd(z.closest('[data-nf-upload]'), e.dataTransfer && e.dataTransfer.files);
    });
  });
  document.addEventListener('nf:added', function () {
    setTimeout(function () { document.querySelectorAll('[data-nf-upload]').forEach(multiCount); }, 0);
  });
  document.querySelectorAll('[data-nf-upload]').forEach(multiCount);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    root.querySelectorAll('[data-nf-multi-drop] b').forEach(function (b) { b.dataset.label = b.textContent; });
    root.querySelectorAll('[data-nf-upload]').forEach(multiCount);
  });

  // holiday designs: the second photo box only for the Christmas Ornaments design
  function ornamentSync(pdp) {
    pdp.querySelectorAll('[data-nf-ornament-slot]').forEach(function (slot) {
      var picked = Array.prototype.map.call(pdp.querySelectorAll('[data-nf-opt]:checked'), function (r) { return r.value; }).join(' ');
      var show = /ornament/i.test(picked);
      if (!show && slot.classList.contains('is-filled')) clearSlot(slot);
      slot.hidden = !show;
    });
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-nf-opt]')) return;
    var pdp = e.target.closest('[data-nf-pdp]');
    if (pdp) setTimeout(function () { ornamentSync(pdp); }, 0);
  });
  document.querySelectorAll('[data-nf-pdp]').forEach(ornamentSync);
  document.addEventListener('shopify:section:load', function (e) { (e.target || document).querySelectorAll('[data-nf-pdp]').forEach(ornamentSync); });

  // block add to cart until the customer has added what this product needs (runs before the cart handler)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    // the form has an input named "id" (the variant), so form.id would return that input: read the attribute instead
    var fid = form.getAttribute && form.getAttribute('id');
    if (!fid) return;
    var ups = document.querySelectorAll('[data-nf-upload][data-form="' + fid + '"]');
    for (var i = 0; i < ups.length; i++) {
      var up = ups[i];
      var mode = up.dataset.require || 'none';
      if (mode === 'none') continue;
      var hasFile = Array.prototype.some.call(up.querySelectorAll('[data-nf-file]'), function (f) { return f.files && f.files.length; });
      var firstFile = up.querySelector('[data-nf-file]');
      var hasText = Array.prototype.some.call(up.querySelectorAll('[data-nf-ptext]'), function (t) { return t.value.trim() !== ''; });
      var ok = mode === 'photo' ? !!(firstFile && firstFile.files && firstFile.files.length) : (mode === 'text' ? hasText : (hasFile || hasText));
      if (!ok) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(up, mode === 'photo' ? 'Please upload your photo before adding to cart.' : (mode === 'text' ? 'Please type your ' + (((up.querySelector('[data-nf-choice-text] span') || {}).textContent || 'text').replace(/^your\s+/i, '').toLowerCase()) + ' before adding to cart.' : 'Please upload a photo or add your text before adding to cart.'));
        up.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      showError(up, '');
    }
  }, true);

  // start fresh after a successful add, ready for the next print
  document.addEventListener('nf:added', function (e) {
    var form = e.detail;
    var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid) return;
    document.querySelectorAll('[data-nf-file][form="' + fid + '"]').forEach(function (inp) {
      clearSlot(inp.closest('[data-nf-slot]'));
    });
    document.querySelectorAll('textarea[form="' + fid + '"], [data-nf-ptext][form="' + fid + '"]').forEach(function (t) { t.value = ''; });
  });
})();

/* Live product preview: places the customer's photo and text on one or more product scenes */
(function () {
  var desk = window.matchMedia('(min-width: 990px)');

  function loadImg(src) {
    return new Promise(function (res, rej) {
      if (!src) { rej(); return; }
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); };
      i.onerror = rej;
      i.src = src.indexOf('//') === 0 ? 'https:' + src : src;
    });
  }

  var SYSTEM_FONTS = ['georgia', 'times new roman', 'arial', 'helvetica', 'verdana', 'courier new'];
  var SCRIPT_FONTS = /vibes|script|pacifico|bebas|lobster|satisfy|allura|caveat|sacramento|parisienne/i;
  var loadedFontCss = {};

  function fontWeight(name) { return SCRIPT_FONTS.test(name) ? '400' : '700'; }

  function loadFonts(names) {
    var fams = names.filter(function (n) { return n && SYSTEM_FONTS.indexOf(n.toLowerCase()) === -1 && !loadedFontCss[n]; });
    if (!fams.length) return;
    fams.forEach(function (n) { loadedFontCss[n] = true; });
    var q = fams.map(function (n) {
      return 'family=' + encodeURIComponent(n).replace(/%20/g, '+') + (SCRIPT_FONTS.test(n) ? '' : ':wght@400;700');
    }).join('&');
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?' + q + '&display=swap';
    document.head.appendChild(link);
  }

  function isLight(hex) {
    var m = String(hex).replace('#', '');
    if (m.length === 3) m = m.split('').map(function (x) { return x + x; }).join('');
    var r = parseInt(m.substr(0, 2), 16), g = parseInt(m.substr(2, 2), 16), b = parseInt(m.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.75;
  }

  function parseArea(str) {
    var m = String(str || '').match(/(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)/);
    var a = m ? [m[1], m[2], m[3], m[4]].map(parseFloat) : [20, 20, 60, 60];
    return { x: a[0] / 100, y: a[1] / 100, w: a[2] / 100, h: a[3] / 100 };
  }

  // alt text like "mockup 28,22,44,52 rounded multiply | On the fridge"
  // "mockup quad x1,y1 x2,y2 x3,y3 x4,y4 ; ...more magnets... rounded @square | In hand"
  // corners in % of the photo, clockwise from top-left; @word shows the scene only when that option is chosen
  function parseQuads(head) {
    var at = head.indexOf('quad');
    if (at < 0) return null;
    var body = head.slice(at + 4).split('@')[0];
    var quads = [];
    body.split(';').forEach(function (seg) {
      var n = (seg.match(/-?\d+(?:\.\d+)?/g) || []).map(parseFloat);
      if (n.length >= 8) quads.push([[n[0], n[1]], [n[2], n[3]], [n[4], n[5]], [n[6], n[7]]]);
    });
    return quads.length ? quads : null;
  }

  function parseSpec(spec, src, i) {
    var parts = String(spec).split('|');
    var head = parts[0].toLowerCase();
    var quads = parseQuads(head);
    var tags = (head.match(/@[a-z0-9-]+/g) || []).map(function (x) { return x.slice(1).replace(/[^a-z0-9]/g, ''); });
    var tag = tags[0] || '';
    var frame = parseFloat((head.match(/frame:([\d.]+)/) || [])[1]) || 0;
    var maskName = (head.match(/mask:([a-z0-9._-]+)/) || [])[1] || '';
    var area = parseArea(head);
    if (quads) {
      var xs = [], ys = [];
      quads[0].forEach(function (p) { xs.push(p[0]); ys.push(p[1]); });
      area = { x: Math.min.apply(0, xs) / 100, y: Math.min.apply(0, ys) / 100, w: (Math.max.apply(0, xs) - Math.min.apply(0, xs)) / 100, h: (Math.max.apply(0, ys) - Math.min.apply(0, ys)) / 100 };
    }
    return {
      src: src,
      quads: quads,
      tag: tag,
      tags: tags,
      frame: frame,
      maskName: maskName,
      area: area,
      shape: /instant/.test(head) ? 'instant' : (/heart/.test(head) ? 'heart' : (/circle|oval/.test(head) ? 'circle' : (/round/.test(head) ? 'rounded' : 'rect'))),
      // "flat": the scene already shows a printed picture, so don't multiply the scene's light over the new photo
      flat: /(^|\s)flat(\s|$)/.test(head),
      blend: /multiply/.test(head) ? 'multiply' : 'source-over',
      label: (parts[1] || '').trim() || 'View ' + (i + 1)
    };
  }

  function Mock(el) {
    var self = this;
    this.el = el;
    this.up = el.closest('[data-nf-upload]');
    this.pdp = el.closest('[data-nf-pdp]');
    this.canvas = el.querySelector('[data-nf-mock-canvas]');
    this.ctx = this.canvas.getContext('2d');
    this.stage = el.querySelector('[data-nf-mock-stage]');
    this.home = el.querySelector('[data-nf-mock-home]');
    this.strip = el.querySelector('[data-nf-mock-scenes]');
    this.zoomEl = el.querySelector('[data-nf-mock-zoom]');
    this.fileEl = el.querySelector('[data-nf-mock-file]');
    this.placeEl = el.querySelector('[data-nf-mock-place]');
    this.hint = el.querySelector('[data-nf-mock-hint]');
    this.zoom = 1; this.nx = 0; this.ny = 0; // offsets as a share of the print area, same for every scene
    var firstColor = el.querySelector('[data-nf-mock-color]');
    var firstFont = el.querySelector('[data-nf-mock-font]');
    this.textColor = firstColor ? firstColor.dataset.nfMockColor : '#2b1a0b';
    this.font = firstFont ? firstFont.dataset.nfMockFont : 'Georgia';
    this.tsize = 1;
    this.tpos = 'bottom';
    this.tposChosen = false;
    this.cur = 0;
    var fontNames = Array.prototype.map.call(el.querySelectorAll('[data-nf-mock-font]'), function (b) { return b.dataset.nfMockFont; });
    loadFonts(fontNames);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.render(); });
    this.overlay = null;
    this.assetBase = el.dataset.assetBase || '';
    // sample photos shown on every magnet until the customer uploads their own
    this.defaults = [];
    this.defaultText = el.dataset.defaultText || '';
    try {
      JSON.parse(el.dataset.defaults || '[]').forEach(function (u, k) {
        loadImg(u).then(function (im) { self.defaults[k] = im; self.render(); }).catch(function () {});
      });
    } catch (e) {}

    var list = [];
    try { list = JSON.parse((el.querySelector('[data-nf-scenes]') || {}).textContent || '[]'); } catch (e) {}
    this.fromPhotos = list.length > 0;
    if (this.fromPhotos) {
      this.scenes = list.map(function (s, i) { return parseSpec(s.spec, s.src, i); });
    } else {
      this.scenes = [{
        src: this.variantImage() || el.dataset.base,
        area: parseArea(el.dataset.area),
        shape: el.dataset.shape || 'rect',
        blend: el.dataset.blend === 'multiply' ? 'multiply' : 'source-over',
        label: 'Preview'
      }];
      if (el.dataset.overlay) loadImg(el.dataset.overlay).then(function (i) { self.overlay = i; self.render(); }).catch(function () {});
    }
    this.pickVisible();
    this.buildStrip();
    this.loadVisible();
    this.bind();
    this.place();
    if (desk.addEventListener) desk.addEventListener('change', function () { self.place(); });
    else if (desk.addListener) desk.addListener(function () { self.place(); });
  }

  Mock.prototype.variantImage = function () {
    if (this.el.dataset.useVariantImage !== '1' || !this.pdp) return null;
    var vEl = this.pdp.querySelector('[data-nf-variants]');
    var idEl = this.pdp.querySelector('[data-nf-variant-id]');
    if (!vEl || !idEl) return null;
    try {
      var vs = JSON.parse(vEl.textContent);
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(idEl.value) && vs[i].featured_image) {
          var src = vs[i].featured_image.src;
          return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        }
      }
    } catch (e) {}
    return null;
  };

  Mock.prototype.loadScene = function (i) {
    var self = this, sc = this.scenes[i];
    // a hand-made mask of the exact magnet face (when the scene has one)
    if (sc.maskName && this.assetBase && !sc.maskReq) {
      sc.maskReq = true;
      loadImg(this.assetBase + sc.maskName).then(function (m) { sc.maskImg = m; sc.mask = undefined; self.render(); }).catch(function () {});
    }
    if (!sc.src) { sc.img = null; sc.failed = true; this.render(); return; }
    var want = sc.src;
    loadImg(want).then(function (img) {
      if (sc.src !== want) return;
      sc.img = img; sc.mask = undefined; sc.failed = false; self.render();
    }).catch(function () { sc.img = null; sc.failed = true; self.render(); });
  };

  Mock.prototype.selectedValues = function () {
    var v = [];
    if (this.pdp) this.pdp.querySelectorAll('[data-nf-opt]:checked, select[data-nf-opt]').forEach(function (r) { v.push(String(r.value).toLowerCase().replace(/[^a-z0-9]/g, '')); });
    return v;
  };
  // a scene shows when every @tag in its spec matches one of the chosen option values (e.g. @16x20 @portrait)
  Mock.prototype.isVisible = function (sc) {
    if (!sc.tags || !sc.tags.length) return true;
    var sel = this.selectedValues();
    if (!sel.length) return true;
    return sc.tags.every(function (t) { return sel.some(function (x) { return x === t || x.indexOf(t) === 0; }); });
  };
  // frame colour comes from the option whose values look like frame colours
  Mock.prototype.frameColor = function () {
    var map = { black: '#1d1b1a', white: '#f3f1ec', naturalwood: '#b9874f', natural: '#b9874f', wood: '#b9874f', oak: '#c19a6b', espresso: '#4a3324', brown: '#5b3d26', walnut: '#5d4030', gold: '#b8923a', silver: '#a9a9a9', grey: '#8a8a88', gray: '#8a8a88' };
    var sel = this.selectedValues();
    for (var i = 0; i < sel.length; i++) if (map[sel[i]]) return map[sel[i]];
    return '#1d1b1a';
  };
  Mock.prototype.visibleCount = function () {
    var self = this;
    return this.scenes.filter(function (sc) { return self.isVisible(sc); }).length;
  };
  Mock.prototype.firstVisible = function () {
    for (var i = 0; i < this.scenes.length; i++) if (this.isVisible(this.scenes[i])) return i;
    return 0;
  };
  Mock.prototype.pickVisible = function () {
    if (!this.scenes[this.cur] || !this.isVisible(this.scenes[this.cur])) this.cur = this.firstVisible();
  };
  Mock.prototype.applyFilter = function () {
    this.pickVisible();
    this.buildStrip();
    this.loadVisible();
    this.render();
  };
  // only the scenes for the chosen shape are downloaded
  Mock.prototype.loadVisible = function () {
    var self = this;
    this.scenes.forEach(function (sc, i) { if (!sc.requested && self.isVisible(sc)) { sc.requested = true; self.loadScene(i); } });
  };

  Mock.prototype.buildStrip = function () {
    var self = this;
    if (!this.strip) return;
    this.strip.innerHTML = '';
    this.scenes.forEach(function (sc) { sc.thumb = null; });
    if (this.visibleCount() < 2) return;
    this.scenes.forEach(function (sc, i) {
      if (!self.isVisible(sc)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.i = i;
      b.className = 'nf-mock__scene' + (i === self.cur ? ' is-active' : '');
      b.setAttribute('aria-label', sc.label);
      var c = document.createElement('canvas');
      c.width = 160; c.height = 160;
      var l = document.createElement('span');
      l.textContent = sc.label;
      b.appendChild(c); b.appendChild(l);
      b.addEventListener('click', function () { self.show(i); });
      sc.thumb = c;
      self.strip.appendChild(b);
    });
  };

  Mock.prototype.show = function (i) {
    this.cur = i;
    if (this.strip) Array.prototype.forEach.call(this.strip.children, function (b) { b.classList.toggle('is-active', +b.dataset.i === i); });
    this.render();
  };

  // desktop: preview takes over the big gallery image; phones: right under the upload box
  Mock.prototype.place = function () {
    var main = this.pdp && this.pdp.querySelector('.nf-pdp__main');
    // products with sample photos show the live preview as the main picture on phones too
    var withSamples = !!(this.el.dataset.defaults && this.el.dataset.defaults.length > 4);
    if ((desk.matches || withSamples) && main) {
      if (this.stage.parentNode !== main) main.appendChild(this.stage);
      this.stage.classList.add('is-gallery');
    } else {
      if (this.stage.parentNode !== this.home) this.home.appendChild(this.stage);
      this.stage.classList.remove('is-gallery');
    }
    this.updateVisibility();
  };

  Mock.prototype.photo = function () {
    var imgs = this.up.querySelectorAll('[data-nf-slot].is-filled [data-nf-preview]');
    for (var i = 0; i < imgs.length; i++) if (imgs[i].naturalWidth) return imgs[i];
    return null;
  };

  Mock.prototype.photos = function () {
    var out = [];
    this.up.querySelectorAll('[data-nf-slot].is-filled [data-nf-preview]').forEach(function (im) {
      var slot = im.closest('[data-nf-slot]');
      if (im.naturalWidth && !(slot && slot.hidden)) out.push(im);
    });
    return out;
  };

  // the photo for magnet qi: its own upload (each magnet has a slot), else a sample photo
  Mock.prototype.photoFor = function (qi) {
    var slots = Array.prototype.filter.call(this.up.querySelectorAll('[data-nf-slot]'), function (s) { return !s.hidden; });
    var n = Math.max(1, slots.length), s = slots[qi % n];
    var im = s && s.classList.contains('is-filled') ? s.querySelector('[data-nf-preview]') : null;
    if (im && im.naturalWidth) return im;
    var d = this.defaults.filter(Boolean);
    return d.length ? d[qi % d.length] : null;
  };

  Mock.prototype.text = function () {
    var t = this.up.querySelector('[data-nf-ptext]');
    return t ? t.value.trim() : '';
  };

  Mock.prototype.active = function () { return !!(this.photo() || this.text() || this.defaults.filter(Boolean).length); };

  Mock.prototype.updateVisibility = function () {
    var on = this.active();
    this.el.hidden = !on;
    this.stage.hidden = !on || this.stage.classList.contains('is-dismissed');
    var zw = this.el.querySelector('[data-nf-mock-zoomwrap]');
    if (zw) zw.hidden = !this.photo();
    if (this.hint) this.hint.hidden = !this.photo();
    if (this.strip) this.strip.hidden = !on || this.visibleCount() < 2;
    var ts = this.el.querySelector('[data-nf-mock-textstyle]');
    if (ts) ts.hidden = !this.text();
  };

  function dist(a, b) { return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1])); }

  // affine transform that maps triangle s onto triangle d
  function affine(s, d) {
    var x0 = s[0][0], y0 = s[0][1], x1 = s[1][0], y1 = s[1][1], x2 = s[2][0], y2 = s[2][1];
    var det = (x1 - x0) * (y2 - y0) - (x2 - x0) * (y1 - y0);
    function solve(u0, u1, u2) {
      var A = ((u1 - u0) * (y2 - y0) - (u2 - u0) * (y1 - y0)) / det;
      var C = ((u2 - u0) * (x1 - x0) - (u1 - u0) * (x2 - x0)) / det;
      return [A, C, u0 - A * x0 - C * y0];
    }
    var U = solve(d[0][0], d[1][0], d[2][0]), V = solve(d[0][1], d[1][1], d[2][1]);
    return [U[0], V[0], U[1], V[1], U[2], V[2]];
  }

  // projective point for (u, v) in 0..1 across the magnet's four corners (keeps perspective natural)
  function homography(P) {
    var x0 = P[0][0], y0 = P[0][1], x1 = P[1][0], y1 = P[1][1], x2 = P[2][0], y2 = P[2][1], x3 = P[3][0], y3 = P[3][1];
    var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
    var den = dx1 * dy2 - dx2 * dy1 || 1e-9;
    var g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
    var a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, c = x0, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3, f = y0;
    return function (u, v) { var w = g * u + h * v + 1; return [(a * u + b * v + c) / w, (d * u + e * v + f) / w]; };
  }

  function warpGrid(ctx, img, fw, fh, P) {
    var H = homography(P), N = 6;
    for (var i = 0; i < N; i++) {
      for (var j = 0; j < N; j++) {
        var u0 = i / N, u1 = (i + 1) / N, v0 = j / N, v1 = (j + 1) / N;
        var a = H(u0, v0), b = H(u1, v0), c = H(u1, v1), d = H(u0, v1);
        var sa = [u0 * fw, v0 * fh], sb = [u1 * fw, v0 * fh], sc = [u1 * fw, v1 * fh], sd = [u0 * fw, v1 * fh];
        drawTri(ctx, img, [sa, sb, sd], [a, b, d]);
        drawTri(ctx, img, [sb, sc, sd], [b, c, d]);
      }
    }
  }

  function drawTri(ctx, img, s, d) {
    var cx = (d[0][0] + d[1][0] + d[2][0]) / 3, cy = (d[0][1] + d[1][1] + d[2][1]) / 3;
    ctx.save();
    ctx.beginPath();
    d.forEach(function (p, i) {
      var dx = p[0] - cx, dy = p[1] - cy, l = Math.sqrt(dx * dx + dy * dy) || 1;
      var x = p[0] + dx / l * 1.6, y = p[1] + dy / l * 1.6;
      if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
    });
    ctx.closePath();
    ctx.clip();
    var m = affine(s, d);
    ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    ctx.drawImage(img, 0, 0);
    ctx.restore();
  }

  // pixels that belong to the blank magnet (light, grey) stay; fingers, clips and shadows on top stay visible
  // From the blank magnet in the scene photo we keep two things:
  //  - a mask: only light, grey pixels (the blank face) get the photo, so fingers, clips and shadows stay on top
  //  - a shade map: the face's own light and shadow, multiplied over the photo so it sits in the scene naturally
  Mock.prototype.maskFor = function (sc) {
    if (sc.maskName && !sc.maskImg) return null;
    if (sc.mask !== undefined) return sc.mask;
    sc.mask = null; sc.shade = null;
    var img = sc.img;
    if (!img) return null;
    try {
      var W = Math.min(1000, img.naturalWidth), H = Math.round(W * img.naturalHeight / img.naturalWidth);
      var m = document.createElement('canvas');
      m.width = W; m.height = H;
      var mc = m.getContext('2d');
      mc.drawImage(img, 0, 0, W, H);
      var data = mc.getImageData(0, 0, W, H), px = data.data;
      var sh = mc.createImageData(W, H), sp = sh.data;
      var lums = [];
      for (var i = 0; i < px.length; i += 4) {
        var r = px[i], g = px[i + 1], b = px[i + 2];
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        var lum = 0.299 * r + 0.587 * g + 0.114 * b;
        // the whole magnet (face and edge) is light and grey; skin, wood, ribbons etc. are not
        var a = Math.max(0, Math.min(1, (lum - 105) / 30)) * Math.max(0, Math.min(1, (46 - (mx - mn)) / 14));
        sp[i] = sp[i + 1] = sp[i + 2] = lum;
        sp[i + 3] = Math.round(a * 255);
        if (a > 0.9 && (i & 28) === 0) lums.push(lum);
        px[i] = px[i + 1] = px[i + 2] = 0;
        px[i + 3] = Math.round(a * 255);
      }
      if (sc.maskImg) {
        var mk = document.createElement('canvas');
        mk.width = W; mk.height = H;
        var mkc = mk.getContext('2d');
        mkc.drawImage(sc.maskImg, 0, 0, W, H);
        var md = mkc.getImageData(0, 0, W, H).data;
        for (var q = 0; q < px.length; q += 4) { px[q + 3] = md[q]; sp[q + 3] = md[q]; }
      }
      lums.sort(function (x, y) { return x - y; });
      var ref = lums.length ? lums[Math.floor(lums.length * 0.9)] : 230;
      for (var j = 0; j < sp.length; j += 4) {
        // 1.0 where the face is at its brightest, a little darker where the scene shades it
        var v = Math.min(255, Math.round(255 * Math.pow(Math.min(1, sp[j] / ref), 1.15)));
        sp[j] = sp[j + 1] = sp[j + 2] = v;
      }
      mc.putImageData(data, 0, 0);
      var s = document.createElement('canvas');
      s.width = W; s.height = H;
      s.getContext('2d').putImageData(sh, 0, 0);
      sc.mask = m; sc.shade = s;
    } catch (e) { sc.mask = null; sc.shade = null; }
    return sc.mask;
  };

  // photo, shape and text inside rectangle r of context c (the flat print)
  Mock.prototype.paintFlat = function (c, r, sc, photo, txt) {
    c.save();
    c.beginPath();
    if (sc.shape === 'heart') {
      // same curve as the drawn heart mockups: x=16sin^3 t, y=13cos t-5cos2t-2cos3t-cos4t
      for (var hi = 0; hi <= 120; hi++) {
        var ht = Math.PI * 2 * hi / 120;
        var hx = (16 * Math.pow(Math.sin(ht), 3) + 16) / 32;
        var hy = (11.923 - (13 * Math.cos(ht) - 5 * Math.cos(2 * ht) - 2 * Math.cos(3 * ht) - Math.cos(4 * ht))) / 28.923;
        if (hi === 0) c.moveTo(r.x + hx * r.w, r.y + hy * r.h); else c.lineTo(r.x + hx * r.w, r.y + hy * r.h);
      }
      c.closePath();
    }
    else if (sc.shape === 'circle') c.ellipse(r.x + r.w / 2, r.y + r.h / 2, r.w / 2, r.h / 2, 0, 0, Math.PI * 2);
    else if ((sc.shape === 'rounded' || sc.shape === 'instant') && c.roundRect) c.roundRect(r.x, r.y, r.w, r.h, Math.min(r.w, r.h) * (sc.shape === 'instant' ? 0.03 : 0.06));
    else c.rect(r.x, r.y, r.w, r.h);
    c.clip();
    if (sc.shape === 'instant') {
      // instant-photo look: white card, photo window on top, caption underneath
      c.fillStyle = '#f8f7f3'; c.fillRect(r.x, r.y, r.w, r.h);
      var win = { x: r.x + r.w * 0.06, y: r.y + r.h * 0.05, w: r.w * 0.88, h: r.h * 0.63 };
      if (photo) {
        c.save(); c.beginPath(); c.rect(win.x, win.y, win.w, win.h); c.clip();
        var kk = Math.max(win.w / photo.naturalWidth, win.h / photo.naturalHeight) * this.zoom;
        var ww = photo.naturalWidth * kk, hh = photo.naturalHeight * kk;
        var mxx = Math.max(0, (ww - win.w) / 2), myy = Math.max(0, (hh - win.h) / 2);
        c.drawImage(photo, win.x + (win.w - ww) / 2 + Math.max(-mxx, Math.min(mxx, this.nx * win.w)), win.y + (win.h - hh) / 2 + Math.max(-myy, Math.min(myy, this.ny * win.h)), ww, hh);
        c.restore();
      } else { c.fillStyle = '#e4e1da'; c.fillRect(win.x, win.y, win.w, win.h); }
      if (txt) {
        var lines = String(txt).split(/\s*\/\s*|\n/).filter(Boolean).slice(0, 3);
        var top = win.y + win.h, band = r.y + r.h - top;
        var fam2 = '"' + this.font + '", Georgia, serif', wt2 = fontWeight(this.font);
        c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillStyle = isLight(this.textColor) ? '#2b1a0b' : this.textColor;
        lines.forEach(function (ln, li) {
          var big = li === 0, fs2 = band * (big ? 0.30 : 0.15) * (lines.length > 2 ? 0.85 : 1);
          c.font = wt2 + ' ' + fs2 + 'px ' + fam2;
          while (c.measureText(ln).width > r.w * 0.86 && fs2 > 5) { fs2 -= 0.5; c.font = wt2 + ' ' + fs2 + 'px ' + fam2; }
          var yy = top + band * (lines.length === 1 ? 0.5 : (0.32 + li * (0.56 / Math.max(1, lines.length - 1))));
          c.fillText(ln, r.x + r.w / 2, yy, r.w * 0.88);
        });
      }
      var g2 = c.createLinearGradient(r.x, r.y, r.x + r.w * 0.7, r.y + r.h * 0.7);
      g2.addColorStop(0, 'rgba(255,255,255,0.10)'); g2.addColorStop(1, 'rgba(255,255,255,0)');
      c.fillStyle = g2; c.fillRect(r.x, r.y, r.w, r.h);
      c.restore();
      return;
    }
    if (photo) {
      var k = Math.max(r.w / photo.naturalWidth, r.h / photo.naturalHeight) * this.zoom;
      var w = photo.naturalWidth * k, h = photo.naturalHeight * k;
      var mx = Math.max(0, (w - r.w) / 2), my = Math.max(0, (h - r.h) / 2);
      var ox = Math.max(-mx, Math.min(mx, this.nx * r.w));
      var oy = Math.max(-my, Math.min(my, this.ny * r.h));
      c.globalCompositeOperation = sc.quads ? 'source-over' : sc.blend;
      c.drawImage(photo, r.x + (r.w - w) / 2 + ox, r.y + (r.h - h) / 2 + oy, w, h);
      c.globalCompositeOperation = 'source-over';
      if (sc.quads) {
        // soft glossy sheen like a real printed magnet
        var gl = c.createLinearGradient(r.x, r.y, r.x + r.w * 0.7, r.y + r.h * 0.7);
        gl.addColorStop(0, 'rgba(255,255,255,0.10)');
        gl.addColorStop(0.45, 'rgba(255,255,255,0.04)');
        gl.addColorStop(1, 'rgba(255,255,255,0)');
        c.fillStyle = gl;
        c.fillRect(r.x, r.y, r.w, r.h);
      }
    } else if (txt) {
      c.fillStyle = 'rgba(255,255,255,.55)';
      c.fillRect(r.x, r.y, r.w, r.h);
    }
    if (txt) {
      var fam = '"' + this.font + '", Georgia, serif';
      var wt = fontWeight(this.font);
      var fs = Math.max(6, Math.min(r.h * 0.12, r.w * 0.12) * this.tsize);
      var font = function () { return wt + ' ' + fs + 'px ' + fam; };
      c.font = font();
      while (c.measureText(txt).width > r.w * 0.9 && fs > 6) { fs -= 0.5; c.font = font(); }
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      var pos = (!photo && !this.tposChosen) ? 'middle' : this.tpos;
      var ty = pos === 'top' ? r.y + fs * 1.1 : (pos === 'middle' ? r.y + r.h / 2 : r.y + r.h - fs * 1.1);
      if (isLight(this.textColor)) { c.shadowColor = 'rgba(0,0,0,.45)'; c.shadowBlur = fs * 0.25; }
      c.fillStyle = this.textColor;
      c.fillText(txt, r.x + r.w / 2, ty, r.w * 0.92);
      c.shadowBlur = 0;
    }
    c.restore();
  };

  // draw one scene onto any canvas
  Mock.prototype.draw = function (canvas, sc, size) {
    var self = this, img = sc.img;
    var W = size, H = img ? Math.round(size * img.naturalHeight / img.naturalWidth) : size;
    if (canvas.width !== W) canvas.width = W;
    if (canvas.height !== H) canvas.height = H;
    var c = canvas.getContext('2d');
    var txt = this.text();
    c.save();
    c.clearRect(0, 0, W, H);
    if (img) c.drawImage(img, 0, 0, W, H);
    else { c.fillStyle = '#f1e2cf'; c.fillRect(0, 0, W, H); }
    if (sc.quads && sc.frame) {
      // floating frame around each canvas: frame width given in % of the image width
      var fw0 = sc.frame / 100 * W, fc = this.frameColor();
      sc.quads.forEach(function (q) {
        var xs = q.map(function (p) { return p[0] / 100 * W; }), ys = q.map(function (p) { return p[1] / 100 * H; });
        var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys), y1 = Math.max.apply(0, ys);
        var gap = fw0 * 0.22;
        c.save();
        c.shadowColor = 'rgba(30,20,10,.35)'; c.shadowBlur = fw0 * 2.2; c.shadowOffsetX = fw0 * 0.5; c.shadowOffsetY = fw0 * 0.9;
        c.fillStyle = fc;
        c.fillRect(x0 - gap - fw0, y0 - gap - fw0, (x1 - x0) + 2 * (gap + fw0), (y1 - y0) + 2 * (gap + fw0));
        c.restore();
        // bevel light on the frame
        var g = c.createLinearGradient(x0 - gap - fw0, y0 - gap - fw0, x1 + gap + fw0, y1 + gap + fw0);
        g.addColorStop(0, 'rgba(255,255,255,.18)'); g.addColorStop(1, 'rgba(0,0,0,.18)');
        c.fillStyle = g;
        c.fillRect(x0 - gap - fw0, y0 - gap - fw0, (x1 - x0) + 2 * (gap + fw0), (y1 - y0) + 2 * (gap + fw0));
        // the dark gap between canvas and floater frame
        c.fillStyle = '#26221e';
        c.fillRect(x0 - gap, y0 - gap, (x1 - x0) + 2 * gap, (y1 - y0) + 2 * gap);
      });
    }
    if (sc.quads) {
      // every magnet in the scene gets a photo (several photos are used in turn), warped to the magnet's corners
      var photos = this.photos();
      var layer = this._layer || (this._layer = document.createElement('canvas'));
      layer.width = W; layer.height = H;
      var lc = layer.getContext('2d');
      var first = null;
      sc.quads.forEach(function (q, qi) {
        var P = q.map(function (p) { return [p[0] / 100 * W, p[1] / 100 * H]; });
        var fw = Math.max(2, (dist(P[0], P[1]) + dist(P[3], P[2])) / 2), fh = Math.max(2, (dist(P[0], P[3]) + dist(P[1], P[2])) / 2);
        var flat = document.createElement('canvas');
        flat.width = Math.ceil(fw); flat.height = Math.ceil(fh);
        self.paintFlat(flat.getContext('2d'), { x: 0, y: 0, w: fw, h: fh }, sc, self.photoFor(qi), txt || self.defaultText);
        warpGrid(lc, flat, fw, fh, P);
        if (!first) first = { x: P[0][0], y: P[0][1], w: fw, h: fh };
      });
      var mask = this.maskFor(sc);
      if (mask) {
        lc.globalCompositeOperation = 'destination-in';
        lc.drawImage(mask, 0, 0, W, H);
        if (sc.shade && !sc.flat) {
          // the scene's own light and shadow, only where the photo is
          var sl = this._shadeLayer || (this._shadeLayer = document.createElement('canvas'));
          sl.width = W; sl.height = H;
          var sx = sl.getContext('2d');
          sx.drawImage(sc.shade, 0, 0, W, H);
          sx.globalCompositeOperation = 'destination-in';
          sx.drawImage(layer, 0, 0);
          lc.globalCompositeOperation = 'multiply';
          lc.drawImage(sl, 0, 0);
        }
        lc.globalCompositeOperation = 'source-over';
      }
      c.drawImage(layer, 0, 0);
      c.restore();
      return first;
    }
    var r = { x: sc.area.x * W, y: sc.area.y * H, w: sc.area.w * W, h: sc.area.h * H };
    this.paintFlat(c, r, sc, this.photo(), txt);
    if (this.overlay && !this.fromPhotos) c.drawImage(this.overlay, 0, 0, W, H);
    c.restore();
    return r;
  };

  Mock.prototype.render = function () {
    this.updateVisibility();
    if (!this.active()) { this.clearExport(); return; }
    this.lastRect = this.draw(this.canvas, this.scenes[this.cur], 1000);
    this.queueExtras();
  };

  // thumbnails and the order snapshot update shortly after the customer stops moving
  Mock.prototype.queueExtras = function () {
    var self = this;
    clearTimeout(this.extraTimer);
    this.extraTimer = setTimeout(function () {
      self.scenes.forEach(function (sc) { if (sc.thumb) self.draw(sc.thumb, sc, 160); });
      self.exportNow();
    }, 250);
  };

  Mock.prototype.clearExport = function () {
    try { this.fileEl.value = ''; } catch (e) {}
    if (this.placeEl) this.placeEl.value = '';
    var fv = this.el.querySelector('[data-nf-mock-fontval]'), cv = this.el.querySelector('[data-nf-mock-colorval]');
    if (fv) fv.value = '';
    if (cv) cv.value = '';
  };

  Mock.prototype.exportNow = function () {
    var self = this;
    if (this.placeEl) {
      this.placeEl.value = 'zoom ' + this.zoom.toFixed(2) + ', move x ' + Math.round(this.nx * 100) + '%, y ' + Math.round(this.ny * 100) + '%' + (this.text() ? ', text size ' + Math.round(this.tsize * 100) + '%, text ' + ((!this.photo() && !this.tposChosen) ? 'middle' : this.tpos) : '');
    }
    var fv = this.el.querySelector('[data-nf-mock-fontval]'), cv = this.el.querySelector('[data-nf-mock-colorval]');
    if (fv) fv.value = this.text() ? this.font : '';
    if (cv) cv.value = this.text() ? this.textColor : '';
    if (typeof DataTransfer === 'undefined') return;
    // the order gets the first scene that fits the chosen options
    var out = document.createElement('canvas');
    this.draw(out, this.scenes[this.firstVisible()], 1000);
    if (!out.toBlob) return;
    try {
      out.toBlob(function (blob) {
        if (!blob) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(new File([blob], 'preview.jpg', { type: 'image/jpeg' }));
          self.fileEl.files = dt.files;
        } catch (e) {}
      }, 'image/jpeg', 0.85);
    } catch (e) { /* image could not be exported (cross-origin); the preview still shows */ }
  };

  Mock.prototype.resetPlacement = function () {
    this.zoom = 1; this.nx = 0; this.ny = 0;
    if (this.zoomEl) this.zoomEl.value = 1;
  };

  Mock.prototype.bind = function () {
    var self = this, drag = null;
    this.canvas.addEventListener('pointerdown', function (e) {
      if (!self.photo()) return;
      drag = { x: e.clientX, y: e.clientY, nx: self.nx, ny: self.ny };
      if (self.canvas.setPointerCapture) self.canvas.setPointerCapture(e.pointerId);
      self.stage.classList.add('is-dragging');
      e.preventDefault();
    });
    this.canvas.addEventListener('pointermove', function (e) {
      if (!drag || !self.lastRect) return;
      var k = self.canvas.width / self.canvas.clientWidth;
      self.nx = drag.nx + (e.clientX - drag.x) * k / self.lastRect.w;
      self.ny = drag.ny + (e.clientY - drag.y) * k / self.lastRect.h;
      // keep within what the current scene allows
      var photo = self.photo(), r = self.lastRect;
      if (photo) {
        var kk = Math.max(r.w / photo.naturalWidth, r.h / photo.naturalHeight) * self.zoom;
        var mx = Math.max(0, (photo.naturalWidth * kk - r.w) / 2) / r.w, my = Math.max(0, (photo.naturalHeight * kk - r.h) / 2) / r.h;
        self.nx = Math.max(-mx, Math.min(mx, self.nx));
        self.ny = Math.max(-my, Math.min(my, self.ny));
      }
      if (!self.raf) self.raf = requestAnimationFrame(function () { self.raf = 0; self.render(); });
    });
    var end = function () { drag = null; self.stage.classList.remove('is-dragging'); };
    this.canvas.addEventListener('pointerup', end);
    this.canvas.addEventListener('pointercancel', end);
    if (this.zoomEl) this.zoomEl.addEventListener('input', function () { self.zoom = parseFloat(self.zoomEl.value) || 1; self.render(); });
    this.el.querySelector('[data-nf-mock-reset]').addEventListener('click', function () { self.resetPlacement(); self.render(); });
    var setActive = function (sel, btn) {
      self.el.querySelectorAll(sel).forEach(function (x) { var on = x === btn; x.classList.toggle('is-active', on); if (x.hasAttribute('aria-checked')) x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    };
    this.el.querySelectorAll('[data-nf-mock-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.textColor = b.dataset.nfMockColor;
        setActive('[data-nf-mock-color]', b);
        var cl = self.el.querySelector('.nf-mock__custom'); if (cl) cl.classList.remove('is-active');
        self.render();
      });
    });
    var custom = this.el.querySelector('[data-nf-mock-custom]');
    if (custom) custom.addEventListener('input', function () {
      self.textColor = custom.value;
      setActive('[data-nf-mock-color]', null);
      custom.parentNode.classList.add('is-active');
      custom.parentNode.style.setProperty('--c', custom.value);
      self.render();
    });
    this.el.querySelectorAll('[data-nf-mock-font]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.font = b.dataset.nfMockFont;
        setActive('[data-nf-mock-font]', b);
        self.render();
        if (document.fonts && document.fonts.load) {
          document.fonts.load(fontWeight(self.font) + ' 40px "' + self.font + '"').then(function () { self.render(); }).catch(function () {});
        }
      });
    });
    var tsize = this.el.querySelector('[data-nf-mock-tsize]');
    if (tsize) tsize.addEventListener('input', function () { self.tsize = parseFloat(tsize.value) || 1; self.render(); });
    this.el.querySelectorAll('[data-nf-mock-pos]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.tpos = b.dataset.nfMockPos; self.tposChosen = true;
        setActive('[data-nf-mock-pos]', b);
        self.render();
      });
    });
    var photosBtn = this.el.querySelector('[data-nf-mock-photos]');
    if (photosBtn) photosBtn.addEventListener('click', function () {
      var off = self.stage.classList.toggle('is-dismissed');
      photosBtn.textContent = off ? 'Show my preview' : 'View product photos';
      self.updateVisibility();
    });
    this.up.addEventListener('input', function (e) { if (e.target.matches('[data-nf-ptext]')) self.render(); });
    this.up.addEventListener('nf:media', function () {
      self.resetPlacement();
      self.stage.classList.remove('is-dismissed');
      if (photosBtn) photosBtn.textContent = 'View product photos';
      self.render();
    });
    if (this.pdp) this.pdp.addEventListener('change', function (e) {
      if (!e.target.matches('[data-nf-opt]')) return;
      if (self.fromPhotos) { setTimeout(function () { self.applyFilter(); }, 0); return; }
      setTimeout(function () {
        var src = self.variantImage() || self.el.dataset.base;
        if (src && src !== self.scenes[0].src) { self.scenes[0].src = src; self.loadScene(0); }
      }, 0);
    });
  };

  function initMocks(root) {
    (root || document).querySelectorAll('[data-nf-mock]').forEach(function (el) {
      if (el._nfMock) return;
      el._nfMock = new Mock(el);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initMocks(document); });
  document.addEventListener('shopify:section:load', function (e) { initMocks(e.target); });
})();

/* Rotating messages in the light top bar */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(root) {
    if (root._nfRot) return;
    var slides = root.querySelectorAll('[data-nf-rot-slide]');
    if (slides.length < 2) return;
    root._nfRot = true;
    var i = 0, timer = null, paused = false;
    var ms = Math.max(3, parseInt(root.dataset.interval, 10) || 5) * 1000;
    function go(n) {
      var cur = slides[i];
      i = (n + slides.length) % slides.length;
      if (cur === slides[i]) return;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      cur.setAttribute('aria-hidden', 'true');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 460);
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
    }
    function start() { stop(); if (!paused && !reduce) timer = setInterval(function () { go(i + 1); }, ms); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = root.querySelector('[data-nf-rot-prev]'), next = root.querySelector('[data-nf-rot-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  }
  function init(r) { (r || document).querySelectorAll('[data-nf-rotator]').forEach(setup); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* "Seen in real life" gallery: tap a photo to see it larger */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nf-lightbox]');
    if (open) {
      var root = open.closest('[data-nf-gallery-root]');
      var dlg = root && root.querySelector('[data-nf-lightbox-dlg]');
      if (!dlg || !dlg.showModal) { window.open(open.dataset.nfLightbox, '_blank'); return; }
      dlg.querySelector('[data-nf-lightbox-img]').src = open.dataset.nfLightbox;
      dlg.querySelector('[data-nf-lightbox-cap]').textContent = open.dataset.caption || '';
      dlg.showModal();
      return;
    }
    if (e.target.closest('[data-nf-lightbox-close]') || e.target.matches('[data-nf-lightbox-dlg]')) {
      var d = e.target.closest('[data-nf-lightbox-dlg]');
      if (d) d.close();
    }
  });
})();

/* "Make it yours" box: product tags at the top switch the box to another product without leaving the page */
(function () {
  var busy = false;
  document.addEventListener('click', function (e) {
    var tag = e.target.closest && e.target.closest('[data-nf-pick]');
    if (!tag || e.metaKey || e.ctrlKey || e.shiftKey || busy) return;
    var box = tag.closest('[data-nf-embed]');
    if (!box || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    if (tag.classList.contains('is-active')) return;
    var nav = tag.closest('[data-nf-pick-nav]');
    var head = nav && nav.closest('.nf-custom__head');
    busy = true;
    box.classList.add('is-loading');
    nav.querySelectorAll('[data-nf-pick]').forEach(function (t) {
      var on = t === tag;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var url = tag.getAttribute('href') + (tag.getAttribute('href').indexOf('?') > -1 ? '&' : '?') + 'view=embed';
    fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-nf-embed]');
      if (!fresh) throw new Error('no box');
      var freshHead = fresh.querySelector('.nf-custom__head');
      var keepX = nav.scrollLeft, keepY = window.scrollY;
      if (freshHead && head) freshHead.replaceWith(head);
      box.replaceWith(fresh);
      // moving the tag row resets its sideways scroll: put it back where the customer left it
      nav.scrollLeft = keepX;
      if (Math.abs(window.scrollY - keepY) > 2) window.scrollTo(0, keepY);
      var r = tag.getBoundingClientRect(), nr = nav.getBoundingClientRect();
      if (r.left < nr.left || r.right > nr.right) nav.scrollBy({ left: r.left - nr.left - (nr.width - r.width) / 2, behavior: 'smooth' });
      (fresh.parentElement || document).dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      busy = false;
    }).catch(function () { busy = false; window.location.href = tag.getAttribute('href'); });
  });
})();

/* phone menu: "See more" reveals the rest of a long list */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nf-more]');
    if (!btn) return;
    var li = btn.closest('li'), id = btn.getAttribute('data-nf-more'), list = li.parentElement;
    list.querySelectorAll('[data-nf-more-item="' + id + '"]').forEach(function (x) { x.hidden = false; });
    li.remove();
  });
})();

/* desktop dropdown: hovering a column can swap the dropdown photo */
(function () {
  document.addEventListener('mouseover', function (e) {
    var col = e.target.closest && e.target.closest('[data-nf-promo-key]');
    if (!col) return;
    var drop = col.parentElement, promo = drop && drop.querySelector('[data-nf-promo]');
    if (!promo) return;
    var key = col.getAttribute('data-nf-promo-key'), tiles = promo.querySelectorAll('[data-nf-promo-for]');
    var hit = Array.prototype.some.call(tiles, function (a) { return a.getAttribute('data-nf-promo-for') === key; });
    tiles.forEach(function (a) { a.classList.toggle('is-on', hit ? a.getAttribute('data-nf-promo-for') === key : a.getAttribute('data-nf-promo-for') === ''); });
  });
})();

/* products tagged 'custom-on-choice': the upload area appears only when a "Custom verse" / "Custom image" choice is picked */
(function () {
  function sync(pdp) {
    var up = pdp.querySelector('[data-nf-on-choice]');
    if (!up) return;
    var vals = [];
    pdp.querySelectorAll('[data-nf-opt]:checked, select[data-nf-opt]').forEach(function (r) { vals.push(String(r.value)); });
    var txt = vals.some(function (x) { return /custom\s*(verse|text|message)/i.test(x); });
    var img = vals.some(function (x) { return /custom\s*(image|photo|picture|design)/i.test(x); });
    up.hidden = !(txt || img);
    up.dataset.require = img ? 'photo' : (txt ? 'text' : 'none');
    var grid = up.querySelector('.nf-upload__grid'), t = up.querySelector('[data-nf-choice-text]');
    if (grid) { grid.hidden = !img; grid.querySelectorAll('[data-nf-file]').forEach(function (f) { f.disabled = !img; }); }
    if (t) { t.hidden = !txt; t.querySelectorAll('textarea, input').forEach(function (f) { f.disabled = !txt; }); }
  }
  function all(root) { (root || document).querySelectorAll('[data-nf-pdp]').forEach(sync); if (root && root.matches && root.matches('[data-nf-pdp]')) sync(root); }
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-nf-opt]')) return;
    var pdp = e.target.closest('[data-nf-pdp]'); if (pdp) sync(pdp);
  });
  document.addEventListener('DOMContentLoaded', function () { all(document); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

/* live "characters left" counter under text boxes marked data-nf-count */
(function () {
  function upd(t) {
    var out = t.parentElement && t.parentElement.querySelector('[data-nf-count-out]');
    if (!out) return;
    var max = parseInt(t.getAttribute('maxlength'), 10) || 200, left = max - t.value.length;
    out.textContent = left + (left === 1 ? ' character left' : ' characters left');
    out.classList.toggle('is-low', left <= 10);
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-nf-count]')) upd(e.target); });
  document.addEventListener('DOMContentLoaded', function () { document.querySelectorAll('[data-nf-count]').forEach(upd); });
  document.addEventListener('nf:added', function () { setTimeout(function () { document.querySelectorAll('[data-nf-count]').forEach(upd); }, 50); });
})();

/* to-scale size guide for canvas / wall products */
(function () {
  var NS = 'http://www.w3.org/2000/svg', uid = 0;
  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function dims(v) { var m = String(v).match(/(\d+(?:\.\d+)?)\s*["″]?\s*x\s*(\d+(?:\.\d+)?)/i); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
  function frameColour(v) {
    v = String(v || '').toLowerCase();
    if (/black/.test(v)) return '#1d1b1a'; if (/white/.test(v)) return '#f3f1ec';
    if (/espresso|brown|walnut/.test(v)) return '#4a3324'; if (/wood|oak|natural/.test(v)) return '#b9874f';
    return null;
  }
  function layout(n) { return ({ 1: [1], 2: [2], 3: [3], 4: [2, 2], 5: [3, 2], 6: [3, 3], 7: [4, 3], 8: [4, 4] })[n] || [n]; }
  function render(box) {
    var pdp = box.closest('[data-nf-pdp]') || document;
    var names = (box.dataset.options || '').split('|').filter(Boolean).map(function (x) { return x.toLowerCase(); });
    var sel = {};
    pdp.querySelectorAll('[data-nf-opt]:checked').forEach(function (r) { sel[names[+r.dataset.nfOpt]] = r.value; });
    // named wall layouts: panels as [x, y, w, h] in inches, 2" gaps
    var LAY = { crown: [[0,0,18,12],[0,14,8,10],[10,14,8,10]], focus: [[0,0,8,10],[10,0,20,16],[32,6,8,10]], soloist: [[0,0,18,26],[20,0,18,12],[20,14,18,12]], pinnacle: [[0,0,18,24],[20,0,34,24],[56,0,18,24]], horizon: [[0,0,18,24],[20,0,18,24],[40,0,18,24]], trio: [[0,0,24,36],[26,0,24,36],[52,0,24,36]] };
    var lkey = String(sel.layout || '').toLowerCase().replace(/^the\s+/, '').split(/[^a-z]/)[0];
    if (LAY[lkey]) return renderLayout(box, LAY[lkey], sel.layout);
    var size = dims(sel.size || ''), orient = (sel.orientation || '').toLowerCase();
    var panels = parseInt(sel.panels, 10) || 1;
    var fc = frameColour(sel.frame);
    if (!size) return;
    var a = Math.min(size[0], size[1]), b = Math.max(size[0], size[1]);
    var pw, ph;
    if (panels > 1 || /each/i.test(sel.size || '')) { pw = a; ph = b; }            // wall-display panels hang portrait
    else if (orient === 'portrait') { pw = a; ph = b; }
    else { pw = b; ph = a; }                                                        // landscape / square / panoramic
    var W = 160, H = 100, floorY = H - 2, cx = 68, cy = floorY - 60;               // inches; art centred 60" above the floor
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img' });
    var id = 'nfsg' + (++uid);
    var defs = el('defs', {});
    var pat = el('pattern', { id: id, patternUnits: 'objectBoundingBox', width: 1, height: 1 });
    var pim = el('image', { href: box.dataset.img, x: 0, y: 0, width: 1, height: 1, preserveAspectRatio: 'xMidYMid slice' });
    pat.setAttribute('patternContentUnits', 'objectBoundingBox'); pat.appendChild(pim); defs.appendChild(pat); svg.appendChild(defs);
    svg.appendChild(el('rect', { x: 0, y: 0, width: W, height: H, fill: '#f6efe6' }));
    svg.appendChild(el('rect', { x: 0, y: floorY, width: W, height: H - floorY, fill: '#d9c4a8' }));
    // other sizes, faint, same orientation, centred
    (box.dataset.sizes || '').split('|').filter(Boolean).forEach(function (v) {
      var d = dims(v); if (!d || panels > 1) return;
      var x = Math.min(d[0], d[1]), y = Math.max(d[0], d[1]), w = orient === 'portrait' ? x : y, h = orient === 'portrait' ? y : x;
      svg.appendChild(el('rect', { x: cx - w / 2, y: cy - h / 2, width: w, height: h, fill: 'none', stroke: '#c9b8a6', 'stroke-width': 0.35, 'stroke-dasharray': '1.2 1' }));
    });
    // the chosen piece (one canvas, or a grid of panels with 2" gaps)
    var rows = layout(panels), gap = 2, totalH = rows.length * ph + (rows.length - 1) * gap;
    rows.forEach(function (count, ri) {
      var rowW = count * pw + (count - 1) * gap, y = cy - totalH / 2 + ri * (ph + gap);
      for (var i = 0; i < count; i++) {
        var x = cx - rowW / 2 + i * (pw + gap);
        if (fc) svg.appendChild(el('rect', { x: x - 1.6, y: y - 1.6, width: pw + 3.2, height: ph + 3.2, fill: fc, stroke: 'rgba(0,0,0,.25)', 'stroke-width': 0.2 }));
        svg.appendChild(el('rect', { x: x + 0.6, y: y + 0.8, width: pw, height: ph, fill: 'rgba(60,40,20,.18)' }));
        svg.appendChild(el('rect', { x: x, y: y, width: pw, height: ph, fill: 'url(#' + id + ')', stroke: 'rgba(0,0,0,.18)', 'stroke-width': 0.2 }));
      }
    });
    // sofa: 84" wide, 32" tall
    var sx = cx - 42, sy = floorY - 32;
    svg.appendChild(el('rect', { x: sx, y: sy + 4, width: 84, height: 24, rx: 3, fill: '#cbbfae' }));
    svg.appendChild(el('rect', { x: sx - 3, y: sy + 10, width: 8, height: 20, rx: 3, fill: '#bfb19e' }));
    svg.appendChild(el('rect', { x: sx + 79, y: sy + 10, width: 8, height: 20, rx: 3, fill: '#bfb19e' }));
    svg.appendChild(el('rect', { x: sx + 4, y: sy + 16, width: 76, height: 9, rx: 2, fill: '#d6cbbb' }));
    svg.appendChild(el('rect', { x: sx + 2, y: floorY - 3, width: 3, height: 3, fill: '#8a7560' }));
    svg.appendChild(el('rect', { x: sx + 79, y: floorY - 3, width: 3, height: 3, fill: '#8a7560' }));
    // person: 66" tall
    var px = 140, top = floorY - 66, g = el('g', { fill: '#a89888' });
    g.appendChild(el('circle', { cx: px, cy: top + 4.5, r: 4.5 }));
    g.appendChild(el('rect', { x: px - 6, y: top + 10, width: 12, height: 24, rx: 4 }));
    g.appendChild(el('rect', { x: px - 5, y: top + 32, width: 4.4, height: 34, rx: 2 }));
    g.appendChild(el('rect', { x: px + 0.6, y: top + 32, width: 4.4, height: 34, rx: 2 }));
    svg.appendChild(g);
    var t = el('text', { x: px, y: top - 2, 'text-anchor': 'middle', 'font-size': 3.4, fill: '#8a7d74' }); t.textContent = "5'6\""; svg.appendChild(t);
    var t2 = el('text', { x: cx, y: floorY - 11, 'text-anchor': 'middle', 'font-size': 3.4, fill: '#8a7d74' }); t2.textContent = '84" sofa'; svg.appendChild(t2);
    var stage = box.querySelector('[data-nf-sg-stage]'); stage.innerHTML = ''; stage.appendChild(svg);
    var label = box.querySelector('[data-nf-sg-label]');
    var desc = panels > 1 ? panels + ' panels, each ' + pw + '" x ' + ph + '"' : pw + '" wide x ' + ph + '" tall';
    var overall = panels > 1 ? ' (about ' + Math.round(Math.max.apply(0, rows.map(function (c) { return c * pw + (c - 1) * gap; }))) + '" x ' + Math.round(totalH) + '" with 2" gaps)' : '';
    label.innerHTML = '<b>Your choice:</b> ' + desc + overall + (fc ? ', in a ' + String(sel.frame).toLowerCase() + ' frame' : '') + (panels > 1 ? '.' : '. Dashed lines show the other sizes.');
  }
  function renderLayout(box, panels, name) {
    var W = 160, H = 100, floorY = H - 2, cx = 68, cy = floorY - 60;
    var tw = 0, th = 0; panels.forEach(function (p) { tw = Math.max(tw, p[0] + p[2]); th = Math.max(th, p[1] + p[3]); });
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img' });
    var id = 'nfsg' + (++uid), defs = el('defs', {});
    var pat = el('pattern', { id: id, patternUnits: 'objectBoundingBox', width: 1, height: 1 }); pat.setAttribute('patternContentUnits', 'objectBoundingBox');
    pat.appendChild(el('image', { href: box.dataset.img, x: 0, y: 0, width: 1, height: 1, preserveAspectRatio: 'xMidYMid slice' })); defs.appendChild(pat); svg.appendChild(defs);
    svg.appendChild(el('rect', { x: 0, y: 0, width: W, height: H, fill: '#f6efe6' }));
    svg.appendChild(el('rect', { x: 0, y: floorY, width: W, height: H - floorY, fill: '#d9c4a8' }));
    var ox = cx - tw / 2, oy = cy - th / 2;
    panels.forEach(function (p) {
      svg.appendChild(el('rect', { x: ox + p[0] + 0.6, y: oy + p[1] + 0.8, width: p[2], height: p[3], fill: 'rgba(60,40,20,.18)' }));
      svg.appendChild(el('rect', { x: ox + p[0], y: oy + p[1], width: p[2], height: p[3], fill: 'url(#' + id + ')', stroke: 'rgba(0,0,0,.18)', 'stroke-width': 0.2 }));
    });
    var sx = cx - 42, sy = floorY - 32;
    svg.appendChild(el('rect', { x: sx, y: sy + 4, width: 84, height: 24, rx: 3, fill: '#cbbfae' }));
    svg.appendChild(el('rect', { x: sx - 3, y: sy + 10, width: 8, height: 20, rx: 3, fill: '#bfb19e' }));
    svg.appendChild(el('rect', { x: sx + 79, y: sy + 10, width: 8, height: 20, rx: 3, fill: '#bfb19e' }));
    svg.appendChild(el('rect', { x: sx + 4, y: sy + 16, width: 76, height: 9, rx: 2, fill: '#d6cbbb' }));
    var px = 140, top = floorY - 66, g = el('g', { fill: '#a89888' });
    g.appendChild(el('circle', { cx: px, cy: top + 4.5, r: 4.5 }));
    g.appendChild(el('rect', { x: px - 6, y: top + 10, width: 12, height: 24, rx: 4 }));
    g.appendChild(el('rect', { x: px - 5, y: top + 32, width: 4.4, height: 34, rx: 2 }));
    g.appendChild(el('rect', { x: px + 0.6, y: top + 32, width: 4.4, height: 34, rx: 2 }));
    svg.appendChild(g);
    var t = el('text', { x: px, y: top - 2, 'text-anchor': 'middle', 'font-size': 3.4, fill: '#8a7d74' }); t.textContent = "5'6\""; svg.appendChild(t);
    var t2 = el('text', { x: cx, y: floorY - 11, 'text-anchor': 'middle', 'font-size': 3.4, fill: '#8a7d74' }); t2.textContent = '84" sofa'; svg.appendChild(t2);
    var stage = box.querySelector('[data-nf-sg-stage]'); stage.innerHTML = ''; stage.appendChild(svg);
    var sizes = panels.map(function (p) { return p[2] + '" x ' + p[3] + '"'; }).join(', ');
    box.querySelector('[data-nf-sg-label]').innerHTML = '<b>Your choice:</b> ' + String(name).split(/\s[–-]\s/)[0] + ', ' + panels.length + ' panels (' + sizes + '), about ' + tw + '" wide x ' + th + '" tall with 2" gaps.';
  }
  function all(root) { (root || document).querySelectorAll('[data-nf-sizeguide]').forEach(render); }
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-nf-opt]')) return;
    var pdp = e.target.closest('[data-nf-pdp]'); if (pdp) pdp.querySelectorAll('[data-nf-sizeguide]').forEach(render);
  });
  document.addEventListener('DOMContentLoaded', function () { all(document); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
